module.exports = __webpack_public_path__ + "media/images/logo/phinoe-13292b60d468c1826fd6637932ca4e15.svg";